import React from 'react';
import { Box, Grid, Skeleton } from '@mui/material';

/**
 * BenefitGridSkeleton
 *
 * 6-tile grid matching BenefitGrid's geometry.
 * - 3 columns md+, 2 columns sm, 1 column xs
 * - Each tile: Skeleton variant="rounded" height={88}, borderRadius: '16px'
 */
function BenefitGridSkeleton() {
  return (
    <Box aria-hidden="true">
      <Grid container spacing={{ xs: 1.5, md: 2 }}>
        {[0, 1, 2, 3, 4, 5].map((i) => (
          <Grid item xs={12} sm={6} md={4} key={i}>
            <Skeleton
              variant="rounded"
              animation="wave"
              height={88}
              sx={{ borderRadius: '16px' }}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default BenefitGridSkeleton;
